import { DriveItemType } from '@/drive/entities/DriveItem';
import { DriveSection } from '@/drive/types/driveSection';
export function getDriveItemId(treeItemId) {
    return !treeItemId || treeItemId === DriveSection.DriveRoot ? null : treeItemId;
}
export function createLocalCollectionItem() {
    return {
        id: -1,
        title: 'New Collection',
        collapsed: true,
        type: DriveItemType.Collection,
        collectionId: '',
    };
}
export function createLocalFolderItem() {
    return {
        id: -1,
        title: 'New Folder',
        collapsed: true,
        type: DriveItemType.Folder,
    };
}
